import RegisteredUsersWidget from './RegisteredUsersWidget';

export default RegisteredUsersWidget;
